import { useSnackbar } from "notistack"
import * as React from "react"

import { Notification } from "./Notification"
import { t } from "ttag"

interface NotificationApi {
  error: (message: string, title?: string) => void,
  show: (title: string, message: string, variant?: "success" | "danger") => void,
  success: (message: string, title?: string) => void,
}

const defaultNotificationApi: NotificationApi = {
  error: (message: string, title?: string) => { /* empty */ },
  show: (title: string, message: string, variant?: "success" | "danger") => { /* empty */ },
  success: (message: string, title?: string) => { /* empty */ },
}

const notificationContext = React.createContext<NotificationApi>(defaultNotificationApi)

const NotificationProvider = (props: { children: React.ReactChild }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  /** Displays the notification with queue management */
  function show(title: string, message: string, variant?: "success" | "danger") {
    enqueueSnackbar(
      "", {
        anchorOrigin: {
          horizontal: "right",
          vertical: "bottom",
        },
        children: (key: number) => (
          <Notification
            key={key}
            onClose={() => closeSnackbar(key)}
            title={title} message={message}
            variant={variant ?? "success"}
          />
        ),
      },
    )
  }

  function success(message: string, title = t`Success`) {
    show(title, message, "success")
  }

  function error(message: string, title = t`Error`) {
    show(title, message, "danger")
  }

  return (
    <notificationContext.Provider value={{ error, show, success }}>{props.children}</notificationContext.Provider>
  )
}

export {
  notificationContext as NotificationContext,
  NotificationProvider,
}
